<div class="fb-expr-editor">
  <!-- Visual Expression Builder -->
  <div class="fb-expr-editor__section">
    <div class="fb-expr-editor__section-header">
      <h6 class="fb-expr-editor__section-title">
        <i class="fa-solid fa-wand-magic-sparkles"></i> Expression Rules
      </h6>
    </div>

    <p class="fb-expr-editor__hint">
      Build conditions visually to control field behavior and set dynamic
      property values.
    </p>

    <div class="fb-expr-editor__builder-container" #builderContainer>
      <formly-form
        [form]="builderForm"
        [fields]="builderFields"
        [model]="builderModel"
        [options]="builderOptions"
        (modelChange)="onBuilderModelChange()">
      </formly-form>
    </div>

    <!-- Generated expression preview -->
    <div
      class="fb-expr-editor__preview"
      *ngIf="(generatedExpressions | keyvalue)?.length">
      <div class="fb-expr-editor__preview-title">
        <i class="fa-solid fa-code"></i> Generated Expressions
      </div>
      <div
        *ngFor="let expr of generatedExpressions | keyvalue"
        class="fb-expr-editor__preview-item">
        <span class="fb-expr-editor__preview-key">{{ expr.key }}</span>
        <code class="fb-expr-editor__preview-value">{{ expr.value }}</code>
      </div>
    </div>
  </div>

  <!-- Expression Tester -->
  <div class="fb-expr-editor__section">
    <div class="fb-expr-editor__section-header">
      <h6 class="fb-expr-editor__section-title">
        <i class="fa-solid fa-flask"></i> Test Expressions
      </h6>
      <button class="fb-expr-editor__template-btn" (click)="populateTestData()">
        <i class="fa-solid fa-wand-magic-sparkles"></i> Auto-fill
      </button>
    </div>
    <p class="fb-expr-editor__hint">
      Set sample values for fields referenced in your expressions, then run to
      verify results.
    </p>
    <div class="fb-expr-editor__tester">
      <label class="fb-expr-editor__tester-label">Model (field values)</label>
      <textarea
        class="fb-expr-editor__tester-input"
        [ngModel]="testModel"
        (ngModelChange)="onTestModelChange($event)"
        placeholder='{"fieldKey": "value"}'
        rows="3">
      </textarea>
      <label class="fb-expr-editor__tester-label">Form State</label>
      <textarea
        class="fb-expr-editor__tester-input"
        [ngModel]="testFormState"
        (ngModelChange)="onTestFormStateChange($event)"
        placeholder='{"FETCHED_DATA": {}}'
        rows="2">
      </textarea>
      <button class="fb-expr-editor__tester-run" (click)="runTests()">
        <i class="fa-solid fa-play"></i> Run
      </button>
      <div
        *ngFor="let r of testResults"
        class="fb-expr-editor__tester-result"
        [class.error]="r.error">
        <span class="fb-expr-editor__tester-key">{{ r.key }}:</span>
        <span *ngIf="!r.error">{{ r.result | json }}</span>
        <span *ngIf="r.error" class="fb-expr-editor__tester-error">{{
          r.error
        }}</span>
      </div>
    </div>
  </div>
</div>
